<template>
  <div class="sharemanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="uid" label="用户编号" width="300"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>

      <el-table-column prop="level" label="是否开启共享盘" width="110">
        <template slot-scope="scope">

          <div v-if="scope.row.nasStatus">
            <el-tag type="success">{{'已开启'}}</el-tag>
          </div>

          <div v-if="!scope.row.nasStatus">
            <el-tag type="warning">{{'未开启'}}</el-tag>
          </div>
          
        </template>
      </el-table-column>

      <el-table-column label="操作"
                       width="300">
        <template slot-scope="scope">
          <el-button @click="resetClick(scope)"
                     style="color:#13aa65;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-folder-checked"></i>重置共享盘密码</el-button>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
export default {
  name: "sharemanagetable",
  props: {
    tableData:Array,
  },
  data() {
    return {
      picMsg:{}
      // tableData: [
        // {
        //   date: "2020-04-21",
        //   type: "公开需求",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // }
      // ]
    };
  },
  methods: {

    resetClick(scope) {
      this.$emit("resetClick", scope);
    },
    quit() {
      this.mydialogVisible = false;
    },
    handleClose() {
      this.mydialogVisible = false;
    },

  },
  created() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}

.el-table ::v-deep .cell .tit:hover{
  text-decoration: underline !important;
}
</style>
